class AdminOrdersController  {
    constructor(createAutoQuery, $session) {
        let options = {
            url: 'QueryCartsJoin.json?StatusNotIn=Cart,DELETED-CART,Deleted',
            pageSize: 12,
            orderBy:'-OrderedOn,-Id',
            autoLoad:true,
            sortOptions:{
                'Id': 'Order #: Low to High',
                '-Id': 'Order #: High to Low',
                'Status,-Id': 'Status: A to Z',
                '-Status,-Id': 'Status: Z to A',
                'OrderedOn,-Id': 'Date: Newest',
                '-OrderedOn,-Id': 'Date: Oldest',
                'GrandTotal,-Id': 'Amount: Low to High',
                '-GrandTotal,-Id': 'Amount: High to Low',
            }
        };
        this.query = createAutoQuery(options);
        this.$session = $session;
    }
    load(){return this.query.load.apply(this.query, arguments);}
}

class AdminOrders{
    constructor(){
        this.bindings= {
            consumerId: '@'
        };
        this.controller = AdminOrdersController;
    }

    templateUrl($element, $attrs) {
        return $attrs.templateUrl || 'admin-orders.html'
    }
}

export default  AdminOrders;

angular.module('emun.shopping.admin').component('adminOrders', new AdminOrders());